export default __webpack_public_path__ + "static/media/php.586a05df.svg";